<template>
  <div class="copywriting" :class="{ more: isMore }">
    <div class="nav clearfix">
      <ul class="options">
        <li :class="{ active: active_nav_idx == 1 }" @click="activeFn(1)">
          已保存文章
        </li>
        <li :class="{ active: active_nav_idx == 0 }" @click="activeFn(0)">
          草稿箱
        </li>
      </ul>
      <div class="other">
        <div class="search-input">
          <input
            type="text"
            class="searchBox"
            v-model="search_value"
            placeholder="输入关键字"
            @keyup.enter="submitFn" />
          <i class="cus-icon icon14"></i>
        </div>
        <el-button v-if="active_nav_idx == 1" type="success" class="sync-btn" @click="syncBtn"><i class="fa fa-weixin"></i>  多图文同步</el-button>
      </div>
    </div>
    <ul class="list_content" v-if="lists && lists.length >0">
      <li v-for="items in lists" :key="items.id">
        <img class="list-img" :src="items.img" />
        <div class="item_box">
          <div class="popup">
            <div class="only-txt" >
              <el-button type="text" @click="popPreviewFn(items)" class="el-icon-view download"></el-button>
              <el-button type="text" @click="electFn(items)" class="el-icon-edit-outline download"></el-button>
              <el-button type="text" class="el-icon-download download"></el-button>
              <el-popover
                popper-class="opreate-popover only-popover"
                placement="top-start"
                trigger="hover"
                content="删除">
                <el-button slot="reference" type="text" @click="deleteArticle(items.id)" class="el-icon-delete level-btn level-btn-on"></el-button>
              </el-popover>
            </div>
          </div>
          <div class="item_text" style="padding-top:10px">{{items.title}}</div>
          <p class="date-template item_text">更新于{{items.createdat}}</p>
        </div>
      </li>
    </ul>
    <div class="prompt" v-if="search_value && lists.length <=0">很抱歉没有找到{{ search_value}}的相关结果</div>
    <div v-infinite-scroll="hideScroll" :infinite-scroll-disabled="busy" :infinite-scroll-distance="10"></div>
    <div v-show="btn_show" class="box_btn">
      <div v-show="isMore" class="less" @click="less_fn"></div>
      <div v-show="!isMore" class="more" @click="more_fn"></div>
    </div>
  </div>
</template>

<script>
import ArticleService from '@/service/api/articleService'

export default {
  name: "comCopywriting",
  data() {
    return {
      isMore: false,
      btn_show: false,
      busy: false,
      search_value: "",
      prompt_value: "搜索 “元宵节” 的结果：",
      prompt_show: false,
      isActive_btn: [true, false],
      active_nav_idx: 1,
      lists: [],
      total: 1,
      searchVal: {
        tag: null,
        page: 0,
        type: 1
      }
    };
  },
  created () {
    if (window.innerWidth > 1780) {
      this.btn_show = true;
    }
    this.getList()
  },
  methods: {
    getList (flag) {
      const articleSystem = new ArticleService()
      articleSystem.articleList(this.searchVal)
        .then(({ data }) => {
          if(flag){
            // 多次加载数据
            this.lists = [
              ...this.lists,
              ...data.data
            ]
            if(data.data.length === 0){
              this.busy = true;
            }else{
              this.busy = false;
            }
          }else{
            // 第一次加载数据
            this.lists = data.data;
            // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
            this.busy = false;
          }
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    hideScroll () {
      this.busy = true;
      // 多次加载数据
      setTimeout(() => {
        if (this.searchVal.page > this.total) {
          return
        } else {
          this.searchVal.page ++;
          this.getList(true);
        }
      }, 1000);
    },
    deleteArticle (id) {
      this.$confirm('您确定要删除此文章吗？', '删除文章')
      .then(() => {
        const articleSystem = new ArticleService()
        articleSystem.deleteArticles({id: id})
          .then(() => {
            this.getList()
          }, (error) => {
           this.$notify.error(error.message)
          })
      })
    },
    popPreviewFn(data) {
      this.$emit("pop_preview", data.content);
      this.$emit("addAricleId", data);
      console.log(data, 999)
    },
    syncBtn () {
      this.$edit.open('syncArticle', '多图文同步', {}, { width: '860px', show: true } )
    },
    activeFn(idx) {
      this.active_nav_idx = idx;
      this.getList()
    },
    electFn(data) {
      this.$confirm('编辑此文章将会覆盖原文章的内容，是否立即编辑？', '编辑文章')
      .then(() => {
        this.$emit("add_ueditor_value", data);
      })
    },
    more_fn() {
      this.isMore = true;
    },
    less_fn() {
      this.isMore = false;
    },
    submitFn() {
      this.searchVal.tag = this.search_value
      this.getList()
    }
  }
};
</script>

<style lang="scss">
.copywriting {
  min-width: 385px;
  width: 385px;
  height: 100%;
  background-color: #ffffff;
  margin-right: 5px;
  color: #535353;
  position: relative;

  &.more {
    min-width: 770px;
    width: 770px;

    .list_content {
      column-count: 2;
      min-height: 100%;
      overflow: auto;
    }
  }
  .clearfix {
    zoom: 1;
    &::after {
      content: "";
      height: 0;
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
    }
  }

  .options {
    min-width: 385px;
    position: relative;
    width: 385px;
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .active {
      color: $color;
      background: #fff;
    }
    li {
      line-height: 48px;
      background: #eee;
      cursor: pointer;
      width: 50%;
      margin-right: 4px;
      text-align: center;
      &:last-child{
        margin-right: 0;
      }
      &:hover {
        color: $color;
        border-bottom: 2px solid $color;
      }
    }
  }
  .other {
    float: left;
    min-width: 385px;
    width: 385px;
    height: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .btn {
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding: 0 10px;
      border-radius: 5px;
      font-size: 14px;
      line-height: 25px;
      &.active {
        border: 1px solid $color;
        background-color: $color;
        color: #ffffff;
      }
    }
  }
  .searchBox {
    background-color: #f0f0f0;
    color: #a9aba8;
    font-size: 12px;
    border-radius: 15px;
    line-height: 25px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 30px 0 15px;
    width: 150px;
    border: none;

    &:hover + .icon14 {
      @extend .icon14_;
    }
  }
  .prompt {
    width: 330px;
    margin: auto;
    line-height: 40px;
    font-size: 13px;
    text-align: center;
    margin-top: 15px;
    background-color: rgba(204, 204, 204, 1);
  }

  .box_btn {
    width: 37px;
    position: absolute;
    top: 50%;
    right: -40px;
    z-index: 5;
    margin-top: -77px;
    display: flex;
    justify-content: space-between;
    div {
      width: 18px;
      height: 77px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .more {
      background-image: url(../assets/images/material_more.png);
    }
    .less {
      background-image: url(../assets/images/material_less.png);
    }
  }

  .list_content {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    min-height: 100%;
    align-content: flex-start;
    // justify-content: space-between;
    padding: 10px 0;

    li {
      cursor: pointer;
      max-width: 49%;
      background-color: #fff;
      overflow: hidden;
      margin: 7px 0 8px 15px;
      width: 170px;
      box-sizing: border-box;
      border: 1px dotted #d9d9d9;
      position: relative;
      font-size: 14px;
      &:hover {
        border: 1px solid $color;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .item_box {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        float: left;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .only-txt{
          width: 100%;
          text-align: center;
          margin-top: 100px;
          .level-btn{
            color: #fa9101;
            font-size: 18px;
            padding: 5px;
            background: #fa9101;
            color: #fff;
            opacity: 1;
          }
          .download{
            color: #7b7b7b;
            background: #fff;
            padding: 5px;
            font-weight: bold;
            font-size: 18px;
          }
        }
        &:hover .popup {
          opacity: 1;
        }
      }

      .popup {
        opacity: 0;
        width: 100%;
        height: 180px;
        display: flex;
        float: left;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.3);
        .border-div {
          width: 100px;
          height: 30px;
          border: 1px solid #ffffff;
          color: #7b7b7b;
          background: #fff;
          margin-top: 5px;
          border-radius: 5px;
          text-align: center;
          line-height: 30px;
          &:hover {
            border: 1px solid $color;
            background-color: $color;
            color: #fff;
          }
        }
        .icon4 {
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
      .item_text {
        width: 100%;
        box-sizing: border-box;
        background-color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 8px 10px;
        text-align: center;
      }
    }
  }

  .title {
    position: relative;
    .dropdown {
      position: absolute;
      left: 0;
      top: 105%;
      display: none;
    }
    &:hover .dropdown {
      display: block;
    }
  }

  .icon14 {
    position: absolute;
    left: 140px;
    top: 65px;
  }
}

// .copywriting li >>> p {
// 	overflow: hidden;
// 	text-overflow: ellipsis;
// 	white-space: nowrap;
// }
</style>



// WEBPACK FOOTER //
// src/components/com-copywriting.vue